import { __ } from '@wordpress/i18n';

const Patterns = () => {
    return (
        <div className="p-4 bg-white rounded shadow-md">
            <h1 className="text-2xl font-bold mb-4">{ __('Patterns', 'my-plugin') }</h1>
            <p>{ __( 'Coming soon! Keep an eye out for this awesome new addition.', 'universal-blocks' ) }</p>
        </div>
    );
};

export default Patterns;
